import Vue from 'vue'
import Router from 'vue-router'
import axios from "@/axios.js"
//import acl from "../src/acl/acl"
Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    redirect: '/dashboard'
                },
                {
                    path: '/dashboard',
                    name: 'dashboard-analytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'directors',
                    }
                },
                {
                    path: '/business/dashboard',
                    name: 'dashboard-business',
                    component: () => import('./views/DashboardBusiness.vue'),
                    meta: {
                        pageTitle: 'Dashborad',
                        rule: 'general'
                    },
                },
                {
                    path: '/clients',
                    name: 'client',
                    component: () => import('./views/pages/client/Clients.vue'),
                    meta: {
                        pageTitle: 'Clients',
                        rule: 'directors'
                    },
                },
                {
                    path: '/products',
                    name: 'products',
                    component: () => import('./views/pages/products/index.vue'),
                    meta: {
                        pageTitle: 'Products',
                        rule: 'directors'
                    },
                },
                {
                    path: '/events',
                    name: 'events',
                    component: () => import('./views/pages/contracts/index.vue'),
                    meta: {
                        pageTitle: 'Events',
                        rule: 'directors'
                    },
                },
                {
                    path: '/tokens',
                    name: 'tokens',
                    component: () => import('./views/pages/tokens/index.vue'),
                    meta: {
                        pageTitle: 'Tokens',
                        rule: 'directors'
                    },
                },
                {
                    path: '/wire_details',
                    name: 'wire_details',
                    component: () => import('./views/pages/wireDetails/index.vue'),
                    meta: {
                        pageTitle: 'wireDetails',
                        rule: 'directors'
                    },
                },
                {
                    path: '/wire_details/:bankid',
                    name: 'singl_bank',
                    component: () => import('@/views/pages/wireDetails/wire.vue'),
                    meta: {
                        pageTitle: 'Bank View',
                        rule: 'directors',
                        breadcrumb: [
                            { title: 'Dashoboard', url: '/' },
                            { title: 'Wire Details', url:'/wire_details'},
                            { title: 'BankView', active: true}
                        ]
                    },
                },
                {
                    path: '/tokens/:tokenId',
                    name: 'tokensPage',
                    component: () => import('@/views/pages/tokens/details.vue'),
                    meta: {
                        pageTitle: 'Tokens View',
                        rule: 'directors',
                        breadcrumb: [
                            { title: 'Dashoboard', url: '/' },
                            { title: 'Tokens', url:'/tokens'},
                            { title: 'TokensView', active: true}
                        ]
                    },
                },
                {
                    path: '/clients/:userId/:email',
                    name: 'clients',
                    component: () => import('@/views/pages/client/Client.vue'),
                    meta: {
                        pageTitle: 'Client View',
                        rule: 'directors',
                        breadcrumb: [
                            { title: 'Dashoboard', url: '/' },
                            { title: 'Clients', url:'/clients'},
                            { title: 'ClientView', active: true}
                        ]
                    },
                },
                {
                    path: '/transactions',
                    name: 'transactions',
                    component: () => import('./views/pages/transactions/index.vue'),
                    meta: {
                        pageTitle: 'Transactions',
                        rule: 'directors'
                    },
                },
                {
                    path: '/addresses',
                    name: 'address',
                    component: () => import('./views/pages/address/index.vue'),
                    meta: {
                        pageTitle: 'Wallets',
                        rule: 'directors'
                    },
                },
                {
                    path: '/transaction/:userId/:email',
                    name: 'transaction',
                    component: () => import('@/views/pages/transactions/details.vue'),
                    meta: {
                        pageTitle: 'Transaction View',
                        rule: 'directors',
                        breadcrumb: [
                            { title: 'Dashoboard', url: '/' },
                            { title: 'Transactions', url:'/transactions'},
                            { title: 'TransactionView', active: true}
                        ]
                    },
                },
                {
                    path: '/splash',
                    name: 'splash',
                    component: () => import('@/views/pages/splash.vue'),
                    meta: {
                        pageTitle: 'Splash',
                        rule: 'directors'
                    },
                },
                {
                    path: '/business/story',
                    name: 'story',
                    component: () => import('./views/pages/business/index.vue'),
                    meta: {
                        pageTitle: 'Story',
                        rule: 'general'
                    },
                },
                {
                    path: '/documents',
                    name: 'documents',
                    component: () => import('./views/pages/documents/index.vue'),
                    meta: {
                        pageTitle: 'Documents',
                        rule: 'directors'
                    },
                },
                {
                    path: '/dod',
                    name: 'dod',
                    component: () => import('./views/pages/dod/index.vue'),
                    meta: {
                        pageTitle: 'Dod',
                        rule: 'admin'
                    },
                },
                {
                    path: '/brokers',
                    name: 'brokers',
                    component: () => import('./views/pages/brokers/index.vue'),
                    meta: {
                        pageTitle: 'Brokers',
                        rule: 'general'
                    },
                },
                /* NEW 12.3.2024 */
                {
                    path: '/brokers/:brokerId',
                    name: 'single_broker',
                    component: () => import('@/views/pages/brokers/broker.vue'),
                    meta: {
                        pageTitle: 'Broker View',
                        rule: 'directors',
                        breadcrumb: [
                            { title: 'Dashoboard', url: '/' },
                            { title: 'Brokers', url:'/brokers'},
                            { title: 'BrokerView', active: true}
                        ]
                    },
                },
                {
                    path: '/crypto',
                    name: 'crypto',
                    component: () => import('./views/pages/crypto/index.vue'),
                    meta: {
                        pageTitle: 'Crypto',
                        rule: 'general'
                    },
                },
                {
                    path: '/brokers/:brokerId',
                    name: 'broker',
                    component: () => import('./views/pages/brokers/details.vue'),
                    meta: {
                        pageTitle: 'Broker',
                        rule: 'super_agents',
                        breadcrumb: [
                            { title: 'Dashoboard', url: '/' },
                            { title: 'Brokers', url:'/brokers'},
                            { title: 'BrokerView', active: true}
                        ]
                    },
                },  
                {
                    path: '/banking/dashboard',
                    name: 'Dashboard',
                    component: () => import('./views/DashboardBanking.vue'),
                    meta: {
                        pageTitle: 'Dashboard',
                        rule: 'super_agents'
                    },
                },
                {
                    path: '/banking/list',
                    name: 'List',
                    component: () => import('./views/pages/banking/bankingList.vue'),
                    meta: {
                        pageTitle: 'List',
                        rule: 'general'
                    },
                },
                {
                    path: '/invoices',
                    name: 'invoices',
                    component: () => import('./views/pages/invoices/invoices.vue'),
                    meta: {
                        pageTitle: 'Invoices',
                        rule: 'admin'
                    },
                },
                {
                    path: '/invoices-v2',
                    name: 'invoicesV2',
                    component: () => import('./views/pages/invoices/index.vue'),
                    meta: {
                        pageTitle: 'Invoices',
                        rule: 'admin'
                    },
                },
                {
                    path: '/invoice/:email',
                    name: 'invoice-maker',
                    component: () => import('./views/pages/invoices/invoiceMaker.vue'),
                    meta: {
                        pageTitle: 'Invoice maker',
                        rule: 'admin'
                    },
                },
                {
                    path: '/risk',
                    name: 'risk',
                    component: () => import('./views/pages/risk/index.vue'),
                    meta: {
                        pageTitle: 'Risk',
                        rule: 'general'
                    },
                },
                {
                    path: '/risk/persons',
                    name: 'risk-persons',
                    component: () => import('./views/pages/risk/details.vue'),
                    meta: {
                        pageTitle: 'Risk-persons',
                        rule: 'general'
                    },
                },
                {
                    path: '/tickets',
                    name: 'tickets',
                    component: () => import('./views/pages/tickets/index.vue'),
                    meta: {
                        pageTitle: 'Tickets',
                        rule: 'general'
                    },
                },
                {
                    path: '/tickets/:userId/:status',
                    name: 'ticket',
                    component: () => import('./views/pages/tickets/detailed.vue'),
                    meta: {
                        pageTitle: 'Ticket',
                        rule: 'general'
                    },
                },
                {
                    path: '/insert_user_aff_program',
                    name: 'insert_user_aff_program',
                    component: () => import('./views/pages/programs/insert_user_aff_program.vue'),
                    meta: {
                        pageTitle: 'insert_user_aff_program',
                        rule: 'admin'
                    },
                },
                {
                    path: '/settings/dictionary',
                    name: 'dictionary',
                    component: () => import('@/views/pages/dictionary/index.vue'),
                    meta: {
                        pageTitle: 'Dictionary',
                        rule: 'admin'
                    },
                },
                {
                    path: '/settings/users',
                    name: 'users',
                    component: () => import('@/views/pages/users/index.vue'),
                    meta: {
                        pageTitle: 'Users',
                        rule: 'admin'
                    },
                },
                {
                    path: '/settings/users/:userName',
                    name: 'user',
                    component: () => import('@/views/pages/users/detailed.vue'),
                    meta: {
                        pageTitle: 'Users',
                        rule: 'admin'
                    },
                }, 
                {
                    path: '/content/blog',
                    name: 'blog',
                    component: () => import('@/views/pages/content/blog.vue'),
                    meta: {
                        pageTitle: 'Blog',
                        rule: 'admin'
                    },
                }, 
                {
                    path: '/content/seo',
                    name: 'seo',
                    component: () => import('@/views/pages/content/seo.vue'),
                    meta: {
                        pageTitle: 'Seo',
                        rule: 'admin'
                    },
                },
                {
                    path: '/content/mailers',
                    name: 'mailers',
                    component: () => import('@/views/pages/content/mailers.vue'),
                    meta: {
                        pageTitle: 'Mailers',
                        rule: 'admin'
                    },
                }, 
                {
                    path: '/content/gallery',
                    name: 'gallery',
                    component: () => import('@/views/pages/content/gallery.vue'),
                    meta: {
                        pageTitle: 'Gallery',
                        rule: 'admin'
                    },
                },  
                {
                    path: '/content/blog/:page',
                    name: 'blogPage',
                    component: () => import('@/views/pages/content/blogPage.vue'),
                    meta: {
                        pageTitle: 'BlogPage',
                        rule: 'admin'                        
                    },
                },           
            ]
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'general'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'general'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () => import('@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'general'
                    }
                },
                {
                    path: '/pages/lock-screen',
                    name: 'page-lock-screen',
                    component: () => import('@/views/pages/LockScreen.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'public'
                    }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach((to) => {
    window.document.title = to.path;
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
    //let that=this;
    axios.post("/api/user-status")
    .then((response) => {
        if(process.env.NODE_ENV === 'production'){
        if(to.name!=='page-login' && response.data.isLoggedIn!==true)
            router.push({ path: '/login'});
        }
       // const userGroup = response.data.group;
        //else if(to.name!=='page-login' && that.$store.state.AppActiveUser.filters===undefined)
        //    router.push({ path: '/login'});
        return next()
    }).catch(() => { })
});

export default router
